module.exports = __webpack_public_path__ + "media/outlander.f7913eb4.mp4";